import React, {useRef} from "react";
import styles from './Menu.module.css';
import {Button} from "primereact/button";
import {Menu} from "primereact/menu";
import Navbar from "./Navbar";

function MenuForm(props) {
    const items = [
        {
            label: 'START',
            className: window.location.pathname === '/' ? styles.selectedItem : styles.item,
            command: () => window.location.href = "/"
        },
        {
            label: 'BILDUNGSANGEBOTE',
            className: window.location.pathname.startsWith('/bildungsangebote') ? styles.selectedItem : styles.item,
            menuRef: useRef(null),
            items: [
                {
                    label: 'IGS-Grundstufe',
                    command: () => window.location.href = "/bildungsangebote/igsgrundstufe"
                },
                {
                    label: 'IGS-Sekundarstufe I',
                    command: () => window.location.href = "/bildungsangebote/igssekundarstufe"
                },
                {
                    label: 'Gymnasiale Oberstufe',
                    command: () => window.location.href = "/bildungsangebote/oberstufe"
                },
                {
                     label: 'Fachoberschule',
                     command: () => window.location.href = "/bildungsangebote/fachoberschule"
                },
                {
                    label: 'Berufsfachschule',
                    command: () => window.location.href = "/bildungsangebote/berufsfachschule"
                },
                {
                    label: 'Höhere Berufsfachschule',
                    command: () => window.location.href = "/bildungsangebote/hoehereberufsfachschule"
                }
            ]

        },

        {
            label: 'ÜBER UNS',
            className: window.location.pathname.startsWith('/uberuns') ? styles.selectedItem : styles.item,
            command: () => window.location.href = "/uberuns"
        },
       {
            label: 'ORGANISATION',
            className: window.location.pathname.startsWith('/organisation') ? styles.selectedItem : styles.item,
            command: () => window.location.href = "/organisation"
        },

       {
          label: 'NEWS',
          className: window.location.pathname.startsWith('/news') ? styles.selectedItem : styles.item,
          command: () => {
              window.location.href = "/news ";
              window.history.pushState(null, '', '/news ');}
       },
       {
           label: 'DOWNLOADS',
           className: window.location.pathname.startsWith('/downloads') ? styles.selectedItem : styles.item,
           command: () => window.location.href = "/downloads"
       },
       {
          label: 'KONTAKT',
          className: window.location.pathname.startsWith('/kontakt') ? styles.selectedItem : styles.item,
          command: () => window.location.href = "/kontakt"
       }
    ]



    const menuLeft = useRef(null);

    return (
        <React.Fragment>
            <div className={styles.root}>
                <div>
                    <Navbar/>
                    <div style={{background: '#004688', height: 5}}/>
                </div>
                <div className="inline lg:hidden" style={{width: '100%'}}>
                    <Menu model={items} popup ref={menuLeft} id="popup_menu_left" style={{width: '350px'}}/>
                    <Button icon="pi pi-bars" onClick={(event) => menuLeft.current.toggle(event)}
                            aria-controls="popup_menu_left" aria-haspopup
                            style={{float: 'right', marginTop: '-60px', marginRight: '20px'}}/>
                </div>
                <div className="hidden lg:inline">
                    <center>
                        <table style={{borderSpacing: 0}} cellSpacing="0" cellPadding="0">
                            <tbody>
                            <tr>
                                {items.map(item => (
                                    <React.Fragment>
                                        {item.command && (
                                            <td className={item.className}
                                                onClick={() => item.command()}>{item.label}</td>
                                        )}

                                        {item.items && (
                                            <React.Fragment>
                                                <td className={item.className}
                                                    onClick={(event) => item.menuRef.current.toggle(event)}>{item.label}
                                                    <Menu model={item.items} popup ref={item.menuRef}
                                                          id="popup_menu_left" style={{width: '350px'}}/>
                                                </td>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
                <div style={{background: '#004688', height: 5}}/>
            </div>
            <div style={{height: 'var(--header-height)'}}>
            </div>

        </React.Fragment>
    );
}

export default MenuForm;
